import { addStoreLocaleByCookie } from 'lib/storeLocale/client'
import { ConstructorResultsSdkResponseObject } from '../../constructorTypes'
import { SearchOptionLinksObject } from '../../types'

export const transformConstructorAutocompleteResults = (
  sections: Record<string, ReadonlyArray<ConstructorResultsSdkResponseObject>>,
  shouldLowerCaseText?: boolean
): ReadonlyArray<SearchOptionLinksObject> => {
  return (sections?.['Search Suggestions'] || []).map(({ value }) => {
    const text = shouldLowerCaseText ? value?.toLowerCase() : value

    return {
      label: text,
      link: addStoreLocaleByCookie(`/all?query=${encodeURIComponent(text)}`),
    }
  })
}
